function trackPlaygroundEvent(name, params = {}) {
  if (typeof window.gtag !== 'function') return

  window.gtag('event', name, {
    event_category: 'playground',
    ...params,
  })
}

export function trackFormulaCopy({
  pageType,
  hubSlug,
  formulaTitle,
  categories,
  source,
} = {}) {
  trackPlaygroundEvent('playground_formula_copy', {
    page_type: pageType,
    hub_slug: hubSlug || undefined,
    formula_title: formulaTitle || undefined,
    categories: categories || undefined,
    source: source || undefined,
  })
}

export function trackCtaClick({
  pageType,
  hubSlug,
  ctaLabel,
  ctaDestination,
} = {}) {
  trackPlaygroundEvent('playground_cta_click', {
    page_type: pageType,
    hub_slug: hubSlug || undefined,
    cta_label: ctaLabel || undefined,
    cta_destination: ctaDestination || undefined,
  })
}

export function trackFormulaLinkClick({
  pageType,
  hubSlug,
  formulaSlug,
  linkLabel,
} = {}) {
  trackPlaygroundEvent('playground_formula_link_click', {
    page_type: pageType,
    hub_slug: hubSlug || undefined,
    formula_slug: formulaSlug || undefined,
    link_label: linkLabel || undefined,
  })
}
